import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export enum AuthorizedUserStatusAction {
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE',
}

interface UpdateAuthorizedUserStatusPayload {
  id: string;
  action: AuthorizedUserStatusAction;
}

const postAuthorizedUserStatus = ({ id, action }: UpdateAuthorizedUserStatusPayload) =>
  api.post(
    action === AuthorizedUserStatusAction.ACTIVATE
      ? API_URL.AUTHORIZED_USERS_ACTIVATE_BY_ID(id)
      : API_URL.AUTHORIZED_USERS_DEACTIVATE_BY_ID(id)
  );

const useUpdateAuthorizedUserStatusQuery = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation(postAuthorizedUserStatus, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_URL.EMPLOYEES_AUTHORIZED_USERS_BY_EMPLOYEE_ID('')],
      });
      if (onSuccess) onSuccess();
    },
  });

  return {
    updateAuthorizedUserStatus: mutateAsync,
    isPending,
  };
};

export default useUpdateAuthorizedUserStatusQuery;
